import moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

export const SHORT_DATE = 'M/D/YY'
export const MEDIUM_DATE = 'MMM D, YYYY'
export const LONG_DATE = 'MMMM D, YYYY'
export const MONTH_YEAR = 'MMMM YYYY'

export default class DateDisplay extends Component {
  static propTypes = {
    date: PropTypes.string,
    format: PropTypes.string
  }

  static defaultProps = {
    format: MEDIUM_DATE
  }

  shouldComponentUpdate(nextProps) {
    const { date, format } = this.props
    return date !== nextProps.date || format !== nextProps.format
  }

  formatDate() {
    const { date, format } = this.props
    const parsedDate = moment(date)

    if (!parsedDate) {
      return null
    }

    return parsedDate.format(format)
  }

  render() {
    return <span>{this.formatDate()}</span>
  }
}



// WEBPACK FOOTER //
// ../src/components/DateDisplay.js